




























import { DimensionItemDto } from '@/services/dimension';
import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import DragMode from './drag-mode.vue';
import SqlMode from './sql-mode.vue';
@Component({
  components: { DragMode, SqlMode }
})
export default class DimensionForm4 extends Vue {
  @Prop() syncMode!: number;
  @Prop() dimFieldList!: DimensionItemDto[];
  @PropSync('dimSyncDefs') syncDimSyncDefs!: any;

  inputdataConfig: any[] = [];

  @Watch('dimFieldList')
  onDimFieldListChange() {}

  @Watch('syncDimSyncDefs')
  onSyncDimSyncDefsChange() {
    this.inputdataConfig = JSON.parse(JSON.stringify(this.syncDimSyncDefs.inputdataConfig));
  }

  @Watch('inputdataConfig')
  onInputdataConfigChange() {
    this.syncDimSyncDefs.inputdataConfig = this.inputdataConfig;
  }

  get xWidth() {
    return 200 * this.dimFieldList.length + 120;
  }

  created() {
    this.inputdataConfig = JSON.parse(JSON.stringify(this.syncDimSyncDefs.inputdataConfig));
  }

  addList() {
    this.inputdataConfig.push({});
  }
  
  removeList(index: number) {
    this.inputdataConfig.splice(index, 1);
  }

}
